import controller from './settings.controller';
import template from './settings.html';

export default {
    template,
    controller
};
